<template lang="pug">
.item(
  @click="onClick($event)"
  @mouseover="mouseOver"
  @mouseleave="timeoutHide()"
  :class="{ hasSubitems }"
) {{item.title}}
  .subitems(v-show="hasSubitems && this.visibleSubitems")
    Item(v-for="subitem in item.subitems"
      :key="subitem.title"
      :item="subitem"
      :args="args"
      :delay="delay"
      :menuHovered="menuHovered"
      )
</template>

<script>
import hideMixin from './debounceHide'

export default {
  name: 'Item',
  mixins: [hideMixin('hideSubitems')],
  props: { item: Object, args: Object, menuHovered: Boolean },
  data() {
    return {
      visibleSubitems: false, 
    }
  },
  computed: {
    hasSubitems() {
      return this.item.subitems
    }
  },
  methods: {   
    mouseOver() {
      this.$parent.$children.forEach((sibling) => {
        if(sibling.visibleSubitems){
          sibling.hideSubitems(true);
        }
      });
      this.showSubitems();
    },
    showSubitems() {
      this.visibleSubitems = true;
      this.cancelHide();
    },
    hideSubitems(hard) {
      if(this.menuHovered || hard){
        this.visibleSubitems = false;
      }else{
        this.visibleSubitems = true;
        this.cancelHide();
      }
    },
    onClick(e) {
      e.stopPropagation();
      
      if(this.item.onClick)
        this.item.onClick(this.args);
      this.$root.$emit('hide');
    }
  }
}
</script>


<style lang="sass" scoped>
@import '../vars.sass'
@import '../common.sass'

.item
  @extend .item
  &.hasSubitems:after
    content: '►'
    position: absolute
    opacity: 0.6
    right: 5px
    top: 5px
  .subitems
    position: absolute
    top: 0
    left: 100%
    width: $width
    .subitem
      @extend .item
</style>
